import axios from "axios";

// const api_base = 'http://localhost:8080/api/v1/';
const api_base = 'https://api.yelmo.gyh.app/api/v1/';


const configMedia = () =>{
    let token = localStorage.getItem('token')
    return { headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': 'Bearer '+token
      }}
}

const config = () =>{
    // let token = localStorage.getItem('token')
    return { headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer '+token
    }}
}

export const Login = ({email, password}) => {
    var url  = `${api_base}authentication/login`
    console.log(url)

    return axios.post(url,{email, password},config()).then((res)=>{
        //return response(res)
        return res
    }).catch((err)=>{
        return err
    });
  
}

export const Register = (body) => {
    var url  = `${api_base}authentication/register`

    return axios.post(
    url,
    body,
    { headers: {
        "Content-Type": "application/json",
    }}).then((res)=>{
        //return response(res)
        return res
    }).catch((err)=>{
        return err
    });
  
}

// export const Service = (method, service, body) => {
//     var url  = `${api_base}${service}`
//     switch (method) {
//         case "GET":
      
//             return axios.get(url,config()).then((res)=>{
//                 //return response(res)
//                 return res
//             }).catch((err)=>{
//                 return err
//             });

//         case "POSTMEDIA":

//             return axios.post(url,body,configMedia()).then((res)=>{
//                 //return response(res)
//                 return res
//             }).catch((err)=>{
//                 return err
//             });

//         case "POST":

//             return axios.post(url,body,config()).then((res)=>{
//                 //return response(res)
//                 return res
//             }).catch((err)=>{
//                 return err
//             });


           
//         case "PUT":

//             return axios.put(url,body,config()).then((res)=>{
//                 //return response(res)
//                 return res
//             }).catch((err)=>{
//                 return err
//             });
           
            
//         case "DELETE":
//             let token = localStorage.getItem('token')
//             return axios.delete(url,{
//                 headers: {
//                     "Content-Type": "application/json",
//                     'Authorization': 'Bearer '+token
//                 },
//                 data:body
//             }).then((res)=>{
//                 //return response(res)
//                 return res
//             }).catch((err)=>{
//                 return err
//             });
            
          

//         default:
//             break;
//     }
// }


export const Service = (method, service, body) => {
    var url  = `${api_base}${service}`

    let token = localStorage.getItem('token')
    // let token = 'eyJraWQiOiI2TVJTeHBaYjgrbFlcL3B5d3pLTFhZSnR3alBXY0NkQzU5V01QRWQ0SldtOD0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJkMDJiZTQyNi00OGMzLTQyOTktOTY1ZS1hZTA2ZmUzZmQ1NmYiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuZXUtd2VzdC0yLmFtYXpvbmF3cy5jb21cL2V1LXdlc3QtMl9uMmxxaVFPU2QiLCJjbGllbnRfaWQiOiJxYzlncjU5am9kbXI2NDhoc2U2ZmIyNjM1Iiwib3JpZ2luX2p0aSI6IjQwMzY0YmI2LWJiYzMtNDk3Mi04ZTI3LWYzMzhkZWJiMWE5YyIsImV2ZW50X2lkIjoiNzgzYjAyMTAtOTlmMy00ZTBlLWEzYjItMWEwZDE3NmIzYTYyIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTcwNjQyNzA4NSwiZXhwIjoxNzA2NTEzNDg1LCJpYXQiOjE3MDY0MjcwODUsImp0aSI6IjZlYjdmOTQ1LWY0MjgtNDQyYi05ZDFmLWQyNjk0YzY4MGRmYyIsInVzZXJuYW1lIjoiZDAyYmU0MjYtNDhjMy00Mjk5LTk2NWUtYWUwNmZlM2ZkNTZmIn0.0OyR3BKJwpSimh4PPbqh5Cxm004Nuvnh-lzgQ2fVfGeY9Eqo7US_78yzTngoR2Pa1_sV_dEqwe5OoEoEravL2vI9iDvqkWrZ_w9bKgarvPh0zbP5sdTEIMRCEw-4eWEwV1yT_4RGxf062NbWIHFvUyusPihw_QXXUHimB_HYcnT0g5K1pAyoI2rve-QbPhJGWiGYV4LodOsqKCW2dcblvWfBFi11VFicmTj2y1iwrXM-mNvOzac_X33qO1Su6Ck6VCJrEGj_33wNgGExY8bK9tpDyQTLwBJjvhfNOuT8eB5C7QLsx76tLT62Y_hCFl-Ok5CCIBBLMr8_balBLeMbJw'
    switch (method) {
        case "GET":
         

           
                return axios.get(
                url,
                { 
                    headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer '+token
                }}).then((res)=>{
                    //return response(res)
                    return res
                }).catch((err)=>{
                    return err?.response;
                });
        

            

        case "POST":
           
            return axios.post(url,body,config()).then((res)=>{
                //return response(res)
                return res
            }).catch((err)=>{
                return err
            });
        
        case "POSTMEDIA":

            return axios.post(url,body,configMedia()).then((res)=>{
                //return response(res)
                return res
            }).catch((err)=>{
                return err
            });


           
        case "PUT":

            return axios.put(url,body,config()).then((res)=>{
                //return response(res)
                return res
            }).catch((err)=>{
                return err
            });
           
            
        case "DELETE":
            
       
            return axios.delete(url,{
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer '+token
                },
                data:body
            }).then((res)=>{
                //return response(res)
                return res
            }).catch((err)=>{
                return err
            });

        case "PATCH":

            return axios.patch(url,body,config()).then((res)=>{
                //return response(res)
                return res
            }).catch((err)=>{
                return err
            });
      
          

        default:
            break;
    }
}

const downloadInvoice = async (service) => {
    const url = `${api_base}${service}`;
    let token = localStorage.getItem('token');
    const response = await axios.get(url, { 
        responseType: "blob",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
};

export const downloadPDF = async (service, id) => {
    try {
        const fileName = `factura_${id}.pdf`
        const data = await downloadInvoice(service);
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Error descargando el archivo:", error);
    }
};

